
/**
 * 
 * @param { 
 *         code:"COP",
           locale:"es-CO",
           decimal:",",
           showDecimal:false,
           symbol: "$", 
           symbolPosValue: true,
           symbolLiteral: " ",
           group: "."

           } style

 * @param {*} value 
 * @returns 
 */
const priceFormat = (style,value,showSymbol)=>{
    if(!style) return value;
    if(value==="") return value; 
    if(isNaN(parseFloat(value))) return ""; 

    value = parseFloat(value).toFixed(2)

  
    let decimalPart = value%1; 
    let integerPart  = Math.floor(value);   

    if(style.showDecimal==true){
        decimalPart = decimalPart.toFixed(2)
        decimalPart = decimalPart.toString().replace("0.","")
        decimalPart = `${style.decimal}${decimalPart}`
    }else{
        decimalPart=""
    }

    let pos=""; 
    let pre=""

    if(style.symbolPosValue){
        pos=`${style.symbolLiteral}${style.symbol}`
    }else{
        pre=`${style.symbol}${style.symbolLiteral}`
    }

    if(style.group!=""){
        integerPart = groupFormat(integerPart.toString(),style.group); 
    }

    let format; 
    if(showSymbol){
        format = `${pre}${integerPart}${decimalPart}${pos}`
    }else{
       format = `${integerPart}${decimalPart}`
    }

 return format; 
}

const groupFormat = (str,ch)=>{
    let arrayNumber =[...str].reverse(); 
    let newValue=[]; 
    for (let counter = 0; counter <arrayNumber.length ; counter++) {
         let c = arrayNumber[counter]; 
         newValue.push(c); 
         if((counter+1)%3==0 && counter+1<arrayNumber.length)
                newValue.push(ch)
    }

    return newValue.reverse().join("")
}

const formatCurrency = (currency,value,hideSymbol)=>{
    return (currency) ?
           priceFormat(currency.style,value, !hideSymbol):
           value
}

export {   
    priceFormat, 
    formatCurrency
}